import React from 'react'
import styled from 'styled-components'
import EditButton from './EditButton'

const Component = styled.div`
    background: #F5F5F5;
    position: relative;
    display: inline-flex;
    padding: 10px;
    cursor: pointer;
    user-select: none;
    max-width: 100%;
    box-sizing: border-box;

    * {
        max-width: 100%;
        box-sizing: border-box;
    }

    button {
        display: none;
    }

    :hover {
        button {
            display: inline-flex;
        }
    }
`

export default ({type, id, data, onEdit}) => {
    const handleClick = () => {
        onEdit(type, id, data)
    }

    return (
        <Component>
            <span dangerouslySetInnerHTML={{ __html: data.value }} />
            <EditButton onClick={handleClick} />
        </Component>
    )
}
